import React, { useState } from 'react';
import { Form } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import FullCourseTab from './components/FullCourseTab';
import SingleUnitTab from './components/SingleUnitTab';
import UnitCondenserPlanShell from './components/UnitCondenserPlanShell';
import messages from './messages';
import './_ai-assisted-course-authoring-tab.scss';

const AiAssistedCourseAuthoringTab: React.FC = () => {
  const intl = useIntl();
  const [selectedTool, setSelectedTool] = useState('full-course');
  return (
    <div className="ai-assisted-course-authoring-tab">
      <h2>{intl.formatMessage(messages.pageTitle)}</h2>
      <p className="ai-assisted-course-authoring-tab__description">{intl.formatMessage(messages.pageDescription)}</p>
      <Form.Group controlId="ai-assisted-course-authoring-tool">
        <Form.Label>{intl.formatMessage(messages.toolSelectorLabel)}</Form.Label>
        <Form.Control
          as="select"
          value={selectedTool}
          onChange={(event) => setSelectedTool(event.target.value)}
          className="ai-assisted-course-authoring-tab__tool-selector"
        >
          <option value="full-course">{intl.formatMessage(messages.fullCourseTab)}</option>
          <option value="single-unit">{intl.formatMessage(messages.singleUnitTab)}</option>
          <option value="unit-condenser">{intl.formatMessage(messages.unitCondenserTab)}</option>
        </Form.Control>
      </Form.Group>
      {selectedTool === 'full-course' && <FullCourseTab />}
      {selectedTool === 'single-unit' && <SingleUnitTab />}
      {selectedTool === 'unit-condenser' && <UnitCondenserPlanShell />}
    </div>
  );
};

export default AiAssistedCourseAuthoringTab;
